import { useId } from 'react';

import { ScreenSize, useScreenSize } from '../../hooks/useScreenSize';

import styles from './BokehAnimationBox.module.scss';

interface IBokehAnimationBoxProps {
  className?: string;
  secondary?: boolean;
}

const bokehItemsCount = 20;
const bokehItemsArray = new Array(bokehItemsCount).fill(0).map((_, index) => `dot-${index}`);

export const BokehAnimationBox = ({ className = '', secondary = false }: IBokehAnimationBoxProps) => {
  const id = useId();
  const screenSize = useScreenSize();

  return screenSize > ScreenSize.extraSmall ? (
    <div className={`${className} ${styles['bokeh-animation-box']}`}>
      {bokehItemsArray.map((key) => (
        <span className={secondary ? styles['secondary'] : ''} key={`bokeh-${id}-${key}`}></span>
      ))}
    </div>
  ) : (
    <></>
  );
};

export default BokehAnimationBox;
